import AvaliacaoResposta from './AvaliacaoResposta';

/**
 * Objeto que representa uma seção da avaliação
 */
class AvaliacaoSecao {
    
    /**
     * Cria uma nova instância de uma seção
     * Caso os parâmetros não sejam informados, cria com as propriedades vazias
     * 
     * @param {Number|null} id Id da seção na API
     * @param {String|null} titulo Título da seção
     * @param {Number|null} ordem Ordem da seção no questionário
     * @param {Array<AvaliacaoResposta>|null} questoes Questões relacionadas à seção
     */
    constructor (id, titulo, ordem, questoes) {
        /** @member {number} id Id da seção na API */
        this.id = id ?? null;
        /** @member {string} titulo Título da seção */
        this.titulo = titulo ?? '';
        /** @member {boolean} ordem Ordem da seção no questionário */
        this.ordem = ordem ?? 1;
        /** @member {Array<AvaliacaoResposta>|null} questoes Respostas relacionadas à seção */
        this.questoes = questoes ?? [];
    }

    /**
     * Cria uma cópia do objeto
     * @param {AvaliacaoSecao} origem Objeto a ser copiado
     * @returns {AvaliacaoSecao} Novo objeto com os mesmos valores que o original
     */
    static clone(origem) {
        //Copia a lista de seções
        let questoes = null;
        if (origem.questoes)
            questoes = origem.questoes.map(questao => AvaliacaoResposta.clone(questao));
        //Cria um novo objeto com os mesmos valores
        return new AvaliacaoSecao(origem.id, origem.titulo, origem.ordem, questoes);
    }

}

export default AvaliacaoSecao;